<script>
	import DropdownCheckbox from "../../../../components/DropdownCheckbox/DropdownCheckbox.svelte";
	import CustomButton from "../../../../components/CustomButton/CustomButton.svelte";
	import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker.svelte";
	import CustomSearch from "../../../../components/CustomSearch/CustomSearch.svelte";
	import LimitSize from "../../../../components/SizeSelect/limitSize.svelte";
	import { convertDateTime } from "src/services/helpers";
	import { Col, Row } from "sveltestrap";
	import { initPage, masterData } from "src/store/store";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";
	import { debounce } from "lodash";
	import { navigate } from "svelte-routing";
	import queryString from "query-string";

	export let handleVehicleSearch = () => {};
	export let changeSearchParams = () => {};
	export let params = {};

	let plateNo;
	let vehicleId;
	let createdAt;
	let isOpen = false;
	let caseNo;
	let investigator;

	let options = $masterData.carAssetOwners.map((item) => ({
		label: item.name,
		id: item.id,
		selected: false,
	}));

	const debouncedInput = debounce((e) => handleChange(e), 1000);

	function handleChange(value) {
		changeSearchParams(value);
		initPage.set(1);
	}

	function resetFilter() {
		let tab = queryString.parse(location.search).tab || 1;
		initPage.set(1);
		navigate("/issues/case-management" + `?tab=${tab}`);
		changeSearchParams("");
	}

	function toggle() {
		isOpen = !isOpen;
	}

	$: if (params.assetOwnerId) {
		let assetOwnerId = [];
		if (Array.isArray(params.assetOwnerId)) {
			assetOwnerId = params.assetOwnerId.map((val) => parseInt(val));
		} else {
			assetOwnerId = params.assetOwnerId
				.split(",")
				.map((val) => parseInt(val));
		}
		options = options.map((val) => {
			if (assetOwnerId.includes(val.id)) {
				val.selected = true;
			}
			return val;
		});
	} else {
		options = options.map((val) => {
			val.selected = false;
			return val;
		});
	}

	$: if (params.createdAt) {
		createdAt = params.createdAt;
	} else {
		createdAt = "";
	}

	$: if (params.investigator) {
		investigator = params.investigator;
	} else {
		investigator = "";
	}

	$: if (params.caseNo) {
		caseNo = params.caseNo;
	} else {
		caseNo = "";
	}

	$: if (params.plateNo && params.vehicleId) {
		plateNo = params.plateNo;
		vehicleId = params.vehicleId;
	} else {
		plateNo = "";
		vehicleId = "";
	}
</script>

<Row style="padding-right: 0">
	<Col xs={12}>
		<Row>
			<Col xs={9}>
				<Row>
					<Col xs={3}>
						<CustomInput
							placeholder="Case No"
							search
							bind:value={caseNo}
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
							name="caseNo"
						/>
					</Col>
					<Col xs={3}>
						<CustomDatePicker
							onChange={(e) => {
								handleChange({
									createdAt: e.detail,
								});
							}}
							value={createdAt}
							name="createdAt"
							isRange={false}
							placeholder={"Case Created"}
						/>
					</Col>
					<Col xs={3}>
						<CustomSearch
							loadOptions={handleVehicleSearch}
							id={`plateNo`}
							type="text"
							placeholder={`Vehicle No`}
							bind:value={plateNo}
							containerClasses={`search-icon`}
							onSelect={(e) => {
								plateNo = e.detail.label;
								vehicleId = e.detail.value;
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
							handleClear={() => {
								plateNo = "";
								vehicleId = "";
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
						/>
					</Col>
				</Row>
			</Col>
			<Col xs={3} style="position:relative; padding-right:0">
				<LimitSize />

				<!-- DONT FORGET TO CHANGE TO REAL DATE FROM BE -->
				<div class="d-flex justify-content-end">
					<span
						class="on-surface-variant"
						style="text-align: end; white-space: nowrap"
						>Last updated
						{convertDateTime(new Date(), "MMM D, h:mm A")}
					</span>
				</div>
			</Col>
		</Row>
		<Row class="mb-3">
			<Col xs={9}>
				<Row>
					<Col xs={3}>
						<CustomInput
							placeholder="Investigator"
							search
							bind:value={investigator}
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
							name="investigator"
						/>
					</Col>
					<Col xs={3}>
						<DropdownCheckbox
							categoryName="Asset Owner"
							options={$masterData.carAssetOwners.map((item) => ({
								label: item.name,
								id: item.id,
								selected: false,
							}))}
							id="assetOwnerId"
							{isOpen}
							{toggle}
							refetch={handleChange}
						/>
						<!-- <CustomSelect
							type="text"
							bind:value={verdict}
							{options}
							error={false}
							errorText=""
							defaultOption="Select Verdict"
						/> -->
					</Col>
					<Col class="d-flex align-items-center">
						<CustomButton
							style="border-color: transparent; font-weight: bold;"
							buttonText="Clear filters"
							onClick={resetFilter}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	</Col>
</Row>
